import { render } from "./UpdateProfileInformationForm.vue?vue&type=template&id=fb09361e&scoped=true"
import script from "./UpdateProfileInformationForm.vue?vue&type=script&lang=js"
export * from "./UpdateProfileInformationForm.vue?vue&type=script&lang=js"

import "./UpdateProfileInformationForm.vue?vue&type=style&index=0&id=fb09361e&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb09361e"]])

export default __exports__